import { useState, useEffect } from 'react';
import axios from 'axios';

// Utiliser une URL absolue pour développement
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

/**
 * Hook pour vérifier l'état de santé de l'application (serveur + BD)
 * @param {number} interval - Intervalle de vérification en millisecondes (défaut: 30000 = 30 secondes)
 * @returns {object} { isOperational: boolean, isLoading: boolean }
 */
export const useHealthCheck = (interval = 30000) => {
  const [isOperational, setIsOperational] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        setIsLoading(true);
        // Utiliser axios directement pour éviter les dépendances circulaires
        const response = await axios.get(`${API_URL}/health`, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
        const status = response.data?.status?.overall;
        setIsOperational(status === 'operational');
      } catch (error) {
        // En cas d'erreur (réseau, serveur down, etc.), considérer comme indisponible
        setIsOperational(false);
      } finally {
        setIsLoading(false);
      }
    };

    // Vérification immédiate
    checkHealth();

    // Vérification périodique
    const healthInterval = setInterval(checkHealth, interval);

    return () => {
      clearInterval(healthInterval);
    };
  }, [interval]);

  return { isOperational, isLoading };
};

